<div id="splash-screen" class="splash-screen">
  <img src="./assets/media/logos/landing-dark.svg" alt="EN KKU logo" class="splash-logo" />
  <div class="splash-spinner" aria-hidden="true"></div>
  <span>โปรดรอสักครู่...</span>
</div>

<div
  class="global-overflow-tooltip-scope"
  appOverflowTooltip
  overflowTooltipDelegate=".form-control, .ng-value-label, .datatable-body-cell-label, .text-truncate, [class*='text-overflow-line-']"
>
  <router-outlet></router-outlet>
</div>

@if (activeKkuWorkloadSync()) {
  <div class="global-sync-lock-backdrop" role="alertdialog" aria-modal="true" aria-live="assertive">
    <section class="global-sync-lock-modal" aria-labelledby="global-sync-lock-title">
      <div class="global-sync-lock-spinner" aria-hidden="true"></div>
      <h2 id="global-sync-lock-title">กำลังนำเข้าข้อมูลจาก REG</h2>
      <p>ระบบกำลัง Sync ข้อมูลรายวิชาและตารางสอน กรุณารอสักครู่</p>
    </section>
  </div>
}

<app-screen-size-detector></app-screen-size-detector>
